import { api } from '../utils/request'

export const custome = async (data) => {
    const resp = await api({
        endpoint: '/customRequest',
        method: 'POST',
        data

    })
    return resp
}